<div class="layout-wrapper">

    <aside class="sidebar">
        <div class="sidebar-header">
            <div class="logo-box"></div> <span class="brand-name">Monitor Panel</span>
        </div>

        <nav class="sidebar-nav">
            <a routerLink="/clients" routerLinkActive="active" class="nav-item">
                <mat-icon>people</mat-icon>
                <span>Clientes</span>
            </a>
            <a routerLink="/analytics" routerLinkActive="active" class="nav-item">
                <mat-icon>bar_chart</mat-icon>
                <span>Analíticas</span>
            </a>
            <a routerLink="/exports" routerLinkActive="active" class="nav-item">
                <mat-icon>file_download</mat-icon>
                <span>Exportaciones</span>
            </a>
            <div style="flex: 1;"></div>
            <div class="nav-divider"></div>

            <button class="logout-btn" (click)="onLogout()">
                <mat-icon>logout</mat-icon>
                <span>Cerrar Sesión</span>
            </button>
        </nav>
    </aside>

    <main class="main-content">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </main>

</div>